import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { history } from './_helpers'
import { alertActions } from './_actions'
import Routes from './Routes'
function App() {
  const alert = useSelector(state => state.alert)
  const dispatch = useDispatch()

  useEffect(() => {
    history.listen((location, action) => {
      dispatch(alertActions.clear())
    })
  }, [dispatch])

  return (
    <div className="jumbotron">
      <div className="container">
        <div className="col-md-8 offset-md-2">
          {alert.message &&
                        <div className={`alert ${alert.type}`}>{alert.message}</div>
          }
          <Routes/>
        </div>
      </div>
    </div>
  )
}

export default App
